<template>
  <ReassuranceItem has-link @click="openExpressReplacementModal">
    <template #icon>
      <IconExpressReplacement class="h-24 w-24 md:h-32 md:w-32" />
    </template>
    <template #title>
      {{ i18n(translations.title) }}
    </template>

    <template #subtitle>{{ i18n(translations.subtitle) }}</template>
  </ReassuranceItem>
  <ExpressReplacementModal />
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { openModal } from '@ds/components/ModalBase'
import { IconExpressReplacement } from '@ds/icons/IconExpressReplacement'

import { MODAL_NAMES } from '~/scopes/product/constants'

import ReassuranceItem from '../ReassuranceItem/ReassuranceItem.vue'

import translations from './ExpressReplacement.translations'
import ExpressReplacementModal from './components/ExpressReplacementModal/ExpressReplacementModal.vue'

const i18n = useI18n()

function openExpressReplacementModal() {
  openModal(MODAL_NAMES.EXPRESS_REPLACEMENT)
}
</script>
